var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "page-left" }, [
      _c("div", {
        staticClass: "el-icon-s-fold",
        on: { click: _vm.handleFold }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "el-icon-refresh-left",
        on: { click: _vm.handleRefresh }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { display: "flex" } }, [
      _c(
        "div",
        { staticClass: "head" },
        [
          _c(
            "el-dropdown",
            { on: { command: _vm.handleCommand } },
            [
              _c("span", { staticClass: "el-dropdown-link" }, [
                _vm._v(
                  "\n            欢迎您," + _vm._s(_vm.name) + "\n            "
                ),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", { attrs: { command: "c" } }, [
                    _vm._v("退出登录")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29e8c3c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e8c3c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = null
// module chunks = 